<template>
  <div>
    <ul
      v-if="colorsHistory?colorsHistory.length:0"
      class="colors history"
    >
      <li
        v-for="item in colorsHistory"
        :key="item"
        class="item"
        @click="selectColor(item)"
      >
        <div
          :style="{ background: `url(${imgAlphaBase64})` }"
          class="alpha"
        />
        <div
          :style="{ background: item }"
          class="color"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin],
  data() {
    return {
      imgAlphaBase64:   '',
      colorsHistory:    [],
      colorsHistoryKey: 'bm-colorpicker-history',
    };
  },
  mounted() {
    this.colorsHistory = JSON.parse(localStorage.getItem(this.colorsHistoryKey));
    console.log(this.colorsHistory);
  },
  created() {
    this.imgAlphaBase64 = this.createAlphaSquare(4).toDataURL();
  },
  methods: {
    selectColor(color) {
      this.$emit('selectColor', color);
    },
  },
};
</script>
